import Cookies from 'js-cookie';

const token = 'tokens';
const roles = 'role';

export function getToken () {
  return Cookies.get(token);
}

export function setToken (tokenVal) {
  return Cookies.set(token, tokenVal);
}

export function removeToken () {
  return Cookies.remove(token);
}

export function getRoles () {
  return Cookies.get(roles);
}

export function setRoles (rolesVal) {
  return Cookies.set(roles, rolesVal);
}

export function removeRoles () {
  return Cookies.remove(roles);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js